<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<div class="trademarkList">
			<!-- 顶部选择器卡片 -->
			<!-- 已选列表 -->
			<div class="isSelect">
				<span>已选分类：</span>
				<span class="isSelectIndex" v-show="isSelectName" style="padding: 5px;margin-right: 10px;">{{isSelectName}}</span>
				<span class="isSelectIndex" v-show="isSelectType" style="padding: 5px;">
					{{isSelectType}}
					<!-- <span class="closeType">x</span> -->
				</span>
			</div>
			<!-- 45类商标分类 -->
			<div class="tradeType">
				<div class="d-flex">
					<div style="padding-left: 10px;">
						<p style="width:80px;">商标分类：</p>
					</div>
					<div style="border-bottom: 1px dashed #f0f0f0;" class="d-flex">
						<div :class="{'text-danger':isSelectHoverIndex === 0}" class="allFont" @mouseout="isSelectHoverIndex = -1">
							<p style="width:50px;" @mousemove="selectAllHover(item,index)" @click="selectAll">全部</p>
						</div>
						<div class="d-flex flex-wrap ml-2">
							<div v-for="(item,index) in tradeTypeList" :key="index" class="pr-3 pb-3"
								@mousemove="selectMove(item,index)" @click="tradeSelected(item,index)"
								@mouseout="isSelectHoverIndex = -1">
								<span :class="{'isSelectIndex':item.id === isSelectHoverIndex}" style="padding: 5px;">
									{{item.name}}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="pt-4 d-flex">
					<div style="padding-left: 10px;">
						<p style="width:75px;text-align: right;">类型：</p>
					</div>
					<div class="d-flex flex-wrap">
						<div v-for="(item,index) in patentType" :key="index" class="pr-3 pb-3"
							@mousemove="selectMoveType(item,index)" @click="tradeSelectType(item,index)"
							@mouseout="isSelectHoverIndex = -1">
							<span :class="{'isSelectIndex':item.id === isSelectHoverIndex}" style="padding: 5px;">
								{{item.name}}
							</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 商品列表 -->
			<div style="display: flex;flex-wrap: wrap;width: 1200px;min-height:500px;">
				<!-- 骨架屏浏览 -->
				<showCardSkeleton v-show="loading"></showCardSkeleton>
				<div v-for="(item,index) in hotPatent" class="mt-4" :key="index" v-show="!loading" style="margin-right: 20px;;">
					<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="item.chargeAmount"
						@click="goodsShow(item.id,'专利交易','/patentList')" style="cursor: pointer;"></show-card>
				</div>
				<div v-show="!loading && hotPatent.length <= 0" style="width: 300px;margin: 10px auto;">
					<el-empty description="暂无数据哦~"></el-empty>
				</div>
			</div>
			<!-- 分页器 -->
			<div style="text-align: center;" class="pt-4">
				<el-pagination background layout="prev, pager, next"
				@current-change="getHotPatent" :current-page="paging.currPage"
				:page-size="paging.everySize" :total="paging.allNum">
				</el-pagination>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import Footer from '@/components/footer/footer.vue'
	import showCardSkeleton from '@/components/skeleton/showCard.vue'
	export default {
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			Footer,
			showCardSkeleton
		},
		data() {
			return {
				tradeTypeList: [{
						name: '农林渔牧/食品',
						id: 1
					},
					{
						name: '交通/运输/包装',
						id: 2
					},
					{
						name: '化工/冶金/生物',
						id: 3
					},
					{
						name: '纺织/造纸',
						id: 4
					},
					{
						name: '建筑/采挖/照明',
						id: 5
					},
					{
						name: '机械/加工/设备',
						id: 6
					},
					{
						name: '服饰/日用/家电',
						id: 7
					},
					{
						name: '通信/电子/数码',
						id: 8
					},
					{
						name: '医疗/保健/美容',
						id: 9
					},
					{
						name: '能源/动力/电力',
						id: 10
					},
					{
						name: '其他',
						id: 11
					}
				],
				patentType:[
					{name:'发明专利',id:12},
					{name:'实用新型专利',id:13},
					{name:'外观专利',id:14},
					{name:'高校专利',id:15},
				],
				hotPatent: [],
				// 鼠标滑过时的index
				isSelectHoverIndex:0,
				isSelectIndex: 0,
				// 鼠标点击后选中的index
				clickSelectIndex: 0,
				isSelectName: '',
				isSelectType:'',
				// 骨架屏显示
				loading:false,
				paging: {currPage: 1, everySize: 20, allNum: 0},
				//检索条件
				condition: {
					type:''
				}
			}
		},
		mounted() {
			// 获取热门推荐-热门专利数据
			this.isSelectName = this.$route.params.selectName || '全部'
			this.isSelectType = this.$route.params.selectType
			this.getHotPatent()
		},
		methods: {
			// 获取热门推荐-热门专利数据
			getHotPatent(currentPage) {
				let vm = this
				vm.loading = true
				if(currentPage){
				   vm.paging.currPage = currentPage;
				} else {
				   vm.paging.currPage = 1;
				}
				vm.axios.get('/api/patent/findAllByPage', {params:{
					type:vm.isSelectType || '',
					patentType:vm.isSelectName == '全部' ? '' : vm.isSelectName,
					currPage: vm.paging.currPage,
					everySize: vm.paging.everySize
				}}).then(res => {
					vm.hotPatent = res.data.data.patents
					vm.paging = res.data.data.pagingBean
					vm.loading = false
				})
			},
			// 鼠标滑过分类列表
			selectMove(item, index) {
				let vm = this
				vm.isSelectHoverIndex = item.id
			},
			// 鼠标滑过类型列表
			selectMoveType(item, index) {
				let vm = this
				vm.isSelectHoverIndex = item.id
			},
			// 滑过全部
			selectAllHover() {
				let vm = this
				vm.isSelectHoverIndex = 0
				vm.clickSelectIndex = 0
			},
			// 选中全部
			selectAll() {
				let vm = this
				vm.isSelectName = '全部'
				vm.isSelectType = ''
				this.getHotPatent()
			},
			// 鼠标点击选中商标分类
			tradeSelected(item, index) {
				let vm = this
				vm.isSelectName = item.name
				vm.isSelectIndex = item.id
				this.getHotPatent()
			},
			// 选中类型
			tradeSelectType(item, index) {
				let vm = this
				vm.isSelectType = item.name
				vm.clickSelectIndex = item.id
				this.getHotPatent()
			},
			// 进入商品详情页
			goodsShow(id,mbx,mbxLink){
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:'patent'
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	/* 商标列表 */
	.trademarkList {
		width: 1200px;
		min-height: 600px;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	/* 已选列表 */
	.isSelect {
		width: 1200px;
		height: 50px;
		line-height: 50px;
		border: 1px solid var(--el-border-color-base);
		padding-left: 10px;
	}
	.closeType{
		width:25px;
		height:25px;
		display: inline-block;
	}
	.closeType:hover{
		background-color: #fff;
		z-index: 999;
	}
	/* 鼠标滑过选中样式 */
	.isSelectIndex {
		background-color: orange;
		color: #fff;
		border-radius: 18px;
		cursor: pointer;
	}

	.allFont:hover {
		cursor: pointer;
		height: 20px;
	}

	/* 45类商标分类 */
	.tradeType {
		width: 1200px;
		border: 1px solid var(--el-border-color-base);
		margin-top: 10px;
		color: #666;
		justify-content: space-between;
		padding-top: 20px;
		padding-bottom: 20px;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>

